export * from './precio-dolar-detail-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/precio-dolar-detail-dialog/index.ts